export default __webpack_public_path__ + "images/SpeakersPhotos/Fermín_Manzanedo.jpg?913f1611";